import ResetButton from './resetButton.view';

export default ResetButton;
